/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useLocation } from '@reach/router';
import { useStaticQuery, graphql } from 'gatsby';

function SEO({ title }) {
  const { pathname } = useLocation();
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
            image
          }
        }
      }
    `
  );

  const keywords = [
    `byteforge`,
    `technology`,
    `software`,
    `partner`,
    `developer`,
    `IT`,
    `website`,
    `application`,
  ];

  const baseTitle = 'ByteForge – Tech Solutions Tailored for You';
  const metaTitle = site.siteMetadata.title;
  const metaDescription = site.siteMetadata.description;
  const siteUrl = site.siteMetadata.siteUrl.replace(/\/+$/, '');
  const metaImage = `${siteUrl}${site.siteMetadata.image}`;

  // Gatsby serves every page with a trailing slash (e.g. /services/), so the
  // canonical URL uses the same form. The 404 page has no canonical URL.
  const isNotFound = /^\/404(\.html|\/)?$/.test(pathname);
  const canonicalPath = pathname.endsWith('/') ? pathname : `${pathname}/`;
  const metaUrl = isNotFound ? null : `${siteUrl}${canonicalPath}`;

  const titleTemplate =
    !title || title === 'Home' ? baseTitle : `${metaTitle} | %s`;

  return (
    <Helmet
      title={title}
      titleTemplate={titleTemplate}
      link={metaUrl ? [{ rel: `canonical`, href: metaUrl }] : []}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        ...(metaUrl ? [{ property: `og:url`, content: metaUrl }] : []),
        {
          property: `og:image`,
          content: metaImage,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:title`,
          content: metaTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        ...(metaUrl ? [{ name: `twitter:url`, content: metaUrl }] : []),
        {
          name: `twitter:image`,
          content: metaImage,
        },
      ].concat(
        keywords.length > 0
          ? {
              name: `keywords`,
              content: keywords.join(`, `),
            }
          : []
      )}
    ></Helmet>
  );
}

SEO.defaultProps = {
  title: ``,
};

SEO.propTypes = {
  title: PropTypes.string.isRequired,
};

export default SEO;
